import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import QuickCompare from './QuickCompare';

// The app runs on JavaScript, so the header's phone menu (site.css, .vc-js) applies from
// the first render. The static pages get the same class from /design/v2/nav.js.
document.documentElement.classList.add('vc-js');

const path = window.location.pathname;
const root = ReactDOM.createRoot(document.getElementById('root'));

if (path === '/compare' || path.startsWith('/compare/')) {
  root.render(<QuickCompare />);
} else {
  root.render(<App />);
}